import { addEvent } from './includes/_events';
import Drawer from '@mozaic-ds/freemarker/js/modules/_drawer.js';
import { getTmsInstance } from '@adeo/tms-lib';
const SHOPPING_LIST_PARAMS_NAME = 'shoppingListParameters';
const IDENTIFIER = 'id';
const OPEN_DRAWER = 'openDrawer';
const WITH_QUANTITY = 'withQuantity';
class AddToShoppingList extends lm.Composant {
  constructor(id) {
    super(id);
    window.SHOPPING_LIST = window.SHOPPING_LIST || {};
    window.SHOPPING_LIST.instances = window.SHOPPING_LIST.instances || {};
    if (!window.SHOPPING_LIST.instances.ShoppingList) {
      window.SHOPPING_LIST.instances.ShoppingList = this;
      addEvent(document, 'click', event => this.addToWishList(event, event.matchingTarget), '.js-shopping-list-button', this);
      const params = this.parseShoppingListParameters();
      if (params[OPEN_DRAWER] === 'true' && params[IDENTIFIER]) {
        const element = document.querySelector(`#${params[IDENTIFIER]}`);
        const quantity = params[WITH_QUANTITY] || undefined;
        this.addToWishList(null, element, quantity).finally(() => {
          const urlWithoutSlParams = new URL(window.location.href);
          urlWithoutSlParams.searchParams.delete(SHOPPING_LIST_PARAMS_NAME);
          window.history.replaceState({}, document.title, urlWithoutSlParams.toString());
        });
      }
    }
    return window.SHOPPING_LIST.instances.ShoppingList;
  }
  parseShoppingListParameters() {
    const raw = new URLSearchParams(window.location.search).get(SHOPPING_LIST_PARAMS_NAME);
    if (!raw) return {};
    return Object.fromEntries(raw.split(';').map(pair => pair.split(':')));
  }
  createShoppingListParameters(params) {
    const url = new URL(window.location.href);
    url.searchParams.set(SHOPPING_LIST_PARAMS_NAME, Object.entries(params).map(([key, value]) => `${key}:${value}`).join(';'));
    return url.toString();
  }
  async addToWishList(event, element, quantity) {
    this.button = element;
    if (!this.button || !this.button.dataset.atcSelector) {
      return;
    }
    const existingDrawers = document.querySelectorAll('.js-shoppinglist-drawers');
    if (existingDrawers) {
      existingDrawers.forEach(drawer => drawer.remove());
    }
    try {
      const offerFormElement = document.querySelector(this.button.dataset.atcSelector);
      if (offerFormElement) {
        this.refLm = offerFormElement.querySelector("input[name='reflm']").value;
        this.offerId = offerFormElement.querySelector("input[name='offerId']").value;
        this.quantity = 1;
        this.quantitySelectorElement = offerFormElement.querySelector("input[name='quantity']");
      }
    } catch (error) {
      throw new Error(error);
    }
    if (this.button.dataset.authenticated === 'true') {
      await this.getShoppingList(quantity);
    } else {
      event?.preventDefault();
      this.redirectToLogin();
    }
  }
  redirectToLogin() {
    const url = new URL(this.button.formAction);
    const params = {
      [OPEN_DRAWER]: 'true',
      [IDENTIFIER]: this.button.id
    };
    if (this.quantitySelectorElement?.value) {
      params[WITH_QUANTITY] = this.quantitySelectorElement.value;
    }
    const refererValue = this.createShoppingListParameters(params);
    url.searchParams.set('referer', refererValue);
    window.location = url;
  }
  async getShoppingList(quantity) {
    const response = await fetch('/shoppinglist/services/list', {
      method: 'GET',
      redirect: 'manual',
      headers: {
        referer: window.document.location,
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
    if (response.ok) {
      const div = document.createElement('div');
      div.innerHTML = await response.text();
      this.button.after(div.querySelector(':first-child'));
      this.selectListDrawer = new Drawer({
        classContent: 'js-select-list-drawer'
      });
      this.selectListDrawer.button = this.selectListDrawer.drawer.querySelector('.js-select-list-drawer-button');
      const el = this.selectListDrawer.drawer.querySelector('.js-select-list-drawer-radio input[type="radio"]:checked');
      if (el) {
        this.selectListDrawer.button.addEventListener('click', () => this.addProductToWishList());
        this.radiosRules(el);
        this.watchFormChanges();
        if (quantity) {
          this.quantity = quantity;
        } else if (this.quantitySelectorElement?.value) {
          this.quantity = this.quantitySelectorElement.value;
        } else {
          this.quantity = 1;
        }
      } else {
        this.selectListDrawer.button.disabled = true;
      }
      setTimeout(() => {
        this.selectListDrawer.open();
      }, 100);
    } else if (response.status === 0) {
      this.redirectToLogin();
    }
  }
  radiosRules(el) {
    this.selectListDrawer.radios = this.selectListDrawer.drawer.querySelectorAll('.js-select-list-drawer-radio input[type="radio"]');
    this.selectListDrawer.input = this.selectListDrawer.drawer.querySelector('.js-select-list-drawer-input');
    this.selectListDrawer.listName = this.selectListDrawer.drawer.querySelectorAll('.js-select-list-drawer-radio label');
    this.selectListDrawer.errorMsg = this.selectListDrawer.drawer.querySelector('.js-error-same-name');
    if (el.target === this.selectListDrawer.radios[this.selectListDrawer.radios.length - 1]) {
      this.selectListDrawer.input.focus();
      this.selectListDrawer.button.disabled = this.selectListDrawer.input.value.length === 0;
      this.listId = null;
    } else {
      this.selectListDrawer.input.value = '';
      this.selectListDrawer.button.disabled = [...this.selectListDrawer.radios].filter(radio => radio.checked).length === 0;
      this.listId = [...this.selectListDrawer.radios].find(radio => radio.checked)?.value;
      this.listName = null;
    }
  }
  watchFormChanges() {
    const lists = [...this.selectListDrawer.listName].map(o => o.innerHTML.trim());
    this.selectListDrawer.radios.forEach(radio => {
      radio.addEventListener('change', el => this.radiosRules(el));
    });
    this.selectListDrawer.input.addEventListener('keyup', () => {
      this.selectListDrawer.radios[this.selectListDrawer.radios.length - 1].checked = true;
      this.selectListDrawer.button.disabled = this.selectListDrawer.input.value.length === 0;
      this.listName = this.selectListDrawer.input.value;
      this.selectListDrawer.errorMsg.classList.toggle('kl-hidden', !lists.includes(this.listName));
      this.selectListDrawer.input.classList.toggle('is-invalid', lists.includes(this.listName));
      this.selectListDrawer.button.disabled = lists.includes(this.listName);
      this.listId = null;
    });
  }
  async addProductToWishList() {
    const data = {
      listId: this.listId,
      listName: this.listName,
      product: {
        refLm: this.refLm,
        quantity: this.quantity,
        offerId: this.offerId
      }
    };
    const response = await fetch('/shoppinglist/services/addProduct', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        referer: window.document.location,
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
    if (response.ok) {
      const div = document.createElement('div');
      div.innerHTML = await response.text();
      this.button.after(div.querySelector(':first-child'));
      this.resultDrawer = new Drawer({
        classContent: 'js-result-drawer'
      });
      lm.lazyload.observe();
      if (data.listName && data.listName !== '') {
        this.trackNewShoppingList();
      } else {
        this.trackAddProductInShoppingList();
      }
      this.resultDrawer.open();
    } else if (response.status === 0) {
      this.redirectToLogin();
    }
  }
  trackNewShoppingList() {
    getTmsInstance().pushEvent(this.selectListDrawer.button, 'cdl_event', {
      event_name: 'product.add_to_wishlist',
      event_data: {
        product_id: this.refLm,
        wishlist_isdefault: false
      }
    });
    getTmsInstance().pushEvent(this.selectListDrawer.button, 'cdl_event', {
      event_name: 'wishlist.creation',
      event_data: {
        wishlist_creation_method: 'pdp',
        wishlist_isdefault: false
      }
    });
  }
  trackAddProductInShoppingList() {
    getTmsInstance().pushEvent(this.selectListDrawer.button, 'cdl_event', {
      event_name: 'product.add_to_wishlist',
      event_data: {
        product_id: this.refLm,
        wishlist_isdefault: true
      }
    });
  }
}
lm.DOMReady(function () {
  new AddToShoppingList('addtoshoppinglist');
});